import { Divider, Grid, Typography } from '@mui/material';

import { InfoCell } from 'components/InfoCell';
import { UserManagementActions } from 'components/UserManagementActions';
import {
  getFullUserNameOrId,
  getLabel,
  userAccountStatusOptions,
} from 'helpers';
import { UserProps } from 'types';

export type UserEditFormProps = {
  user: UserProps;
  setUser: React.Dispatch<React.SetStateAction<UserProps>>;
};

export const UserEditForm = (props: UserEditFormProps) => {
  const system_admin_path = '/home/system_admin_dashboard/users/';
  const signer_path = '/home/signer_dashboard/users/';
  const { user, setUser } = props;
  const { email, account_status } = user;
  return (
    <Grid
      container
      aria-label={
        'Edit page for User ' + user.first_name + ' ' + user.last_name
      }
    >
      <Grid item xs={8}>
        <Typography display='inline' variant='h4'>
          {getFullUserNameOrId(user)}{' '}
        </Typography>

        <Typography
          color={user.role === 'auditor' ? 'primary.main' : 'secondary.main'}
          sx={{ textTransform: 'capitalize', fontWeight: 'bold' }}
          variant='subtitle1'
        >
          {user.role}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <UserManagementActions
          user={user}
          setUser={setUser}
          user_url={user.role === 'signer' ? signer_path : system_admin_path}
        />
      </Grid>
      <Divider sx={{ marginTop: 2, marginBottom: 2, width: '100%' }} />
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={6}>
              <InfoCell title='Username' value={email} />
            </Grid>
            <Grid item xs={6}>
              <InfoCell
                title='Account Status'
                value={getLabel({
                  value: account_status as string,
                  options: userAccountStatusOptions,
                })}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
